<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-shadow"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">리뷰</h3>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-flex xs12 style="padding-bottom: 74px;">
        <v-card tile flat class="card-shadow pa-0 pt-2 ma-0">
          <v-list class="pa-0 px-3">
            <ReviewListTile v-for="(review, index) of reviews" :key="index"
                            :idx="review.idx"
                            :createdAt="review.created_at"
                            :updatedAt="review.updated_at"
                            :contents="review.contents"
                            :user="review.user"
                            :reviewScore="review.review_score" />
          </v-list>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import ReviewListTile from '@/components/ReviewListTile';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Reviews',
    props: [ 'idx' ],
    components: { ReviewListTile },
    computed: {
      ...mapGetters('product', [ 'reviews' ]),
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        page: 1,
        bottom: true,
      };
    },
    created () {
      this.selectReviews({ second: this.time, idx: this.idx, page: this.page }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.bottomVisible);
    },
    destroyed () {
      window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectReviews({ second: this.time, idx: this.idx, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapActions('product', [ 'selectReviews' ]),
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 4px 36px rgba(234, 234, 234, 50);
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

</style>
